import {HitsService} from "@vicman-wi/telemetry-js/esm/hits/HitsService";
import {stringIsTrueValue} from "@vicman-wi/utils-js/esm/string/is-true-value";
import {stringToNumbers} from "@vicman-wi/utils-js/esm/string/to-numbers";
import logger from "./logger";

let instance = null;

/** @return {HitsService} */
export function getHitsService() {
  if (instance) return instance;

  const userGroups = stringToNumbers(process.env.REACT_APP_HITS_USER_GROUPS);

  instance = new HitsService(
  {
    isEnabled: stringIsTrueValue(process.env.REACT_APP_HITS_ENABLED),
    isMuted: userGroups.indexOf(window.clientConfig.splitGroupId) === -1,
    amountModificator: 1 + (1 - userGroups.length / 10),
  }, logger());

    return instance;
  };